module.exports = __webpack_public_path__ + "static/media/moderate-risk-dna.b0295203.svg";